<template>
	<div>
		<div>
			<vx-card title="All Clients" class="mb-5">
				<template slot="actions">
					<vs-button :disabled="loading" @click="Refresh()" icon-pack="feather" icon="icon-refresh-cw" size="small" class="mr-1 mb-1"> {{ loading ? 'Loading...' : 'Refresh' }}</vs-button>
				</template>
				<vs-table search stripe max-items="50" no-data-text="No Clients" pagination :data="clientList" v-model="selectedClient">
					<template slot="header"></template>
					<template slot="thead">
						<vs-th class="logo-col">Logo</vs-th>
						<vs-th sort-key="ClientName">Client</vs-th>
						<vs-th v-if="isAdmin">Color</vs-th>
					</template>
					<template slot-scope="{data}">
						<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :class="{ 'client-row-clickable': isAdmin }" @click.native="OnClientSelected(tr)">
							<vs-td class="logo-col">
								<vs-avatar :src="tr.ClientAvatar" :text="tr.ClientName ? tr.ClientName.substring(0, 1) : '?'" size="40px" />
							</vs-td>
							<vs-td :data="tr.ClientName">{{ tr.ClientName }}</vs-td>
							<vs-td v-if="isAdmin">
								<div :style="{ height: '20px', border: '1px solid white', borderRadius: '2px', backgroundColor: tr.GraphColor }"></div>
							</vs-td>
						</vs-tr>
					</template>
				</vs-table>
			</vx-card>
		</div>

		<vs-prompt :active.sync="brandingModalActive" title="Edit Client Branding" :buttons-hidden="true">
			<div class="mb-4">
				<label class="vs-input--label">Client</label>
				<vs-input class="w-full mt-1" :value="brandingClient.ClientName" disabled />
			</div>

			<div class="mb-4">
				<label class="vs-input--label">Graph Color</label>
				<input type="color" class="w-full mt-1 branding-color-input" v-model="brandingClient.GraphColor">
			</div>

			<div class="mb-4">
				<label class="vs-input--label">Logo</label>
				<div class="flex items-center mt-2">
					<vs-avatar :src="brandingClient.ClientAvatar" :text="brandingClient.ClientName ? brandingClient.ClientName.substring(0, 1) : '?'" size="60px" class="mr-3" />
					<vs-button type="border" @click="$refs.clientLogoInput.click()">Upload Logo</vs-button>
				</div>
				<input ref="clientLogoInput" type="file" class="hidden" accept="image/*" @change="OnClientLogoChanged">
			</div>

			<div class="flex justify-end mt-5">
				<vs-button type="border" class="mr-2" @click="brandingModalActive = false">Cancel</vs-button>
				<vs-button :disabled="savingBranding || !CanSaveBranding()" @click="SaveBranding">{{ savingBranding ? 'Saving...' : 'Save' }}</vs-button>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
export default {
  data () {
    return {
      selectedClient: { ClientName: '', ClientID: 0 },
      loading: false,
      savingBranding: false,
      brandingModalActive: false,
      brandingClient: {
        ClientID: null,
        ClientName: '',
        GraphColor: '#000000',
        ClientAvatar: null,
        ClientAvatarFile: null
      }
    }
  },
  computed: {
    isAdmin () {
      return this.$store.getters.GetIsAdmin
    },
    clientList () {
      return this.$store.getters.GetClientList
    }
  },
  methods: {
    Refresh () {
      this.loading = true
      this.$store.dispatch('ActionFetchGlobalData', { forceRefresh: true }).finally(() => {
        this.loading = false
      })
    },
    GetClientFromID (id) {
      if (this.clientList == null) return null
      return this.clientList.find(x => x.ClientID === id) || null
    },
    OnClientSelected (client) {
      if (!this.isAdmin) return
      this.OpenBrandingModal(client)
    },
    OpenBrandingModal (client) {
      this.brandingClient = {
        ClientID: client.ClientID,
        ClientName: client.ClientName || '',
        GraphColor: client.GraphColor || '#000000',
        ClientAvatar: client.ClientAvatar || null,
        ClientAvatarFile: null
      }
      this.brandingModalActive = true
    },
    OnClientLogoChanged (event) {
      const file = event && event.target && event.target.files && event.target.files[0] ? event.target.files[0] : null
      if (file == null) return
      const reader = new FileReader()
      reader.onload = (e) => {
        const value = (e && e.target && e.target.result) ? e.target.result : ''
        if (typeof value !== 'string') return
        this.brandingClient.ClientAvatar = value
        this.brandingClient.ClientAvatarFile = file
      }
      reader.readAsDataURL(file)
      event.target.value = ''
    },
    CanSaveBranding () {
      if (!this.isAdmin) return false
      if (!this.brandingClient.ClientID) return false
      return /^#[0-9a-fA-F]{6}$/.test((this.brandingClient.GraphColor || '').trim())
    },
    SaveBranding () {
      if (!this.CanSaveBranding()) return
      const payload = new FormData()
      payload.append('ClientID', this.brandingClient.ClientID)
      payload.append('GraphColor', this.brandingClient.GraphColor)
      if (this.brandingClient.ClientAvatarFile != null) {
        payload.append('ClientAvatar', this.brandingClient.ClientAvatarFile)
      }
      this.savingBranding = true
      this.$store.dispatch('ActionUpdateClientBranding', payload)
        .then(() => {
          this.brandingModalActive = false
          this.$vs.notify({
            color: 'success',
            title: 'Client updated',
            text: 'Branding changes were saved.'
          })
        })
        .catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Save failed',
            text: 'Unable to update client branding.'
          })
        })
        .finally(() => {
          this.savingBranding = false
        })
    }
  }
}
</script>

<style scoped>
.branding-color-input {
	height: 40px;
	padding: 0;
	border: 1px solid rgba(0, 0, 0, 0.2);
	border-radius: 4px;
}

.logo-col {
	width: 1%;
	white-space: nowrap;
}

.client-row-clickable {
	cursor: pointer;
}
</style>
